import { useQuery } from '@tanstack/react-query';
import { OpenRecord } from '@/components/queue/queue-parts';
import { useOpenRecord } from '@/components/sheet/use-sheet';
import { Button } from '@/components/ui/button';
import { adminQuery } from '@/lib/query';

/** A customer as a chip: name and masked phone, fetched by id so a raw id never shows. */
export function CustomerChip({ id }: Readonly<{ id: string }>) {
  const customer = useQuery(adminQuery('customers.get', { customer_id: id }));
  const name = customer.data?.name;
  const phone = customer.data?.phone;
  const shown =
    name || phone || (customer.isPending ? 'Loading customer…' : 'Customer');
  return (
    <OpenRecord
      sheetRef={{ type: 'cust', id }}
      label={`Open customer ${shown}`}
      className="flex flex-col hover:underline"
    >
      <span>{shown}</span>
      {name && phone ? (
        <span className="text-xs text-muted-foreground">{phone}</span>
      ) : null}
    </OpenRecord>
  );
}

export function TransactionChip({ id }: Readonly<{ id: string }>) {
  return (
    <OpenRecord
      sheetRef={{ type: 'tx', id }}
      label={`Open transaction ${id.slice(0, 8)}`}
      className="font-mono text-xs hover:underline"
    >
      Transaction · {id.slice(0, 8)}
    </OpenRecord>
  );
}

/** A header button that opens the customer's sheet on top of this one. */
export function ViewCustomerButton({ id }: Readonly<{ id: string }>) {
  const open = useOpenRecord();
  return (
    <Button
      size="sm"
      variant="outline"
      onClick={(event) => open({ type: 'cust', id }, event.currentTarget)}
    >
      View customer
    </Button>
  );
}
